import { type Observable } from 'rxjs';
import { switchMap, map } from 'rxjs-operators';

import { ACCOUNT_PARTNER, ACCOUNT_ENV } from '../settings';
import apiService from './api';
import tokenService, { type TokenService } from './token';

export class LoginService {
  private loggingIn = false;

  constructor(private tokenService: TokenService) {}

  public auth() {
    if (this.loggingIn) {
      return;
    }

    const refreshToken = window.sessionStorage.getItem('refreshToken');

    if (refreshToken) {
      this.parseAuth(
        apiService.post('/auth_v2/refresh', { jwt_refresh_token: refreshToken }).pipe(map(response => response?.data)),
        () => this.handleRefreshError()
      );
    } else {
      const newLogin: Observable<string> = (window as any).Eduzz.Accounts.login(ACCOUNT_PARTNER, ACCOUNT_ENV);

      this.parseAuth(
        newLogin.pipe(
          switchMap(token => apiService.post('/auth_v2/login', { token })),
          map(response => response?.data)
        )
      );
    }
  }

  public logout() {
    this.tokenService.clearToken();
  }

  private handleRefreshError(): void {
    try {
      window.sessionStorage.removeItem('refreshToken');
      this.tokenService.clearToken();
    } catch {}

    this.loggingIn = false;
    this.auth();
  }

  private parseAuth(step: Observable<any>, onError?: (err: any) => void) {
    step.subscribe({
      next: ({ jwt_token: token, jwt_refresh_token: refresh }) => {
        this.tokenService.setTokens({ token, refresh });
        window.history.pushState(null, null, '/');
        this.loggingIn = false;
      },
      error: err => {
        if (onError) {
          onError(err);
          return;
        }

        this.loggingIn = false;
      }
    });
  }
}

const loginService = new LoginService(tokenService);
export default loginService;
